<template>
  <li class="dropright">
    <a class="dropdown-item d-flex align-items-center" href="#"  role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="mr-1">{{menu.title}}</span>
      <em class="fas fa-angle-right ml-auto"></em>

    </a>
    <ul class="dropdown-menu"  aria-labelledby="appsDropdown">
      <template v-for="(data, i) in menu.children">
        <router-link tag="li"  :to="data.path"  v-if=" data.children === undefined || data.children.length === 0">
          <a class="dropdown-item" >{{data.title}}</a>
        </router-link>
        <sub-menu-item :menu="menu.children[i]" v-else></sub-menu-item>
      </template>

    </ul>
  </li><!-- /Apps -->
</template>

<script>
export default {
name: "SubMenuItem",
  props:{
    menu:{
      type:Object
    }
  }
}
</script>